import { useAppStore } from "@/store/useAppStore";
import React from "react";

export const EstimateDistribution = () => {
  const { crowdData, selectedChallenge } = useAppStore();
  if (!crowdData?.distribution) {
    return null;
  }
  return (
    <div>
      <h4 className="text-lg font-bold mb-4">Estimate Distribution:</h4>
      <div className="space-y-2">
        {crowdData.distribution.map((bucket: any, i: number) => (
          <div
            key={i}
            className="flex justify-between items-center p-2 bg-white/5 rounded-lg"
          >
            <span className="text-sm">{bucket.range}</span>
            <div className="flex items-center space-x-2">
              <div className="w-24 bg-gray-700 rounded-full h-2">
                <div
                  className="h-2 rounded-full bg-blue-400"
                  style={{
                    width: `${
                      (bucket.count / crowdData.participantCount) * 100
                    }%`,
                  }}
                ></div>
              </div>
              <span className="text-xs">{bucket.count}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-blue-500/20 rounded-xl border border-blue-500/30">
        <p className="text-sm text-blue-300">
          📊 Crowd average: {crowdData.crowdAverage}
          <br />
          🎯 Correct answer: {selectedChallenge.correctAnswer}
        </p>
      </div>
    </div>
  );
};
